module.exports = __webpack_public_path__ + "media/images/powerpoint/ecole-du-vin-de-bordeaux-background-4384dab6a40142da75f5dfda27514761.png";